import { render, staticRenderFns } from "./AddExamEntrance.vue?vue&type=template&id=4f51c705&"
import script from "./AddExamEntrance.vue?vue&type=script&lang=js&"
export * from "./AddExamEntrance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports